import { render, staticRenderFns } from "./Divisions.vue?vue&type=template&id=3b8453a4&scoped=true&"
import script from "./Divisions.vue?vue&type=script&lang=js&"
export * from "./Divisions.vue?vue&type=script&lang=js&"
import style0 from "./Divisions.vue?vue&type=style&index=0&id=3b8453a4&prod&lang=scss&"
import style1 from "./Divisions.vue?vue&type=style&index=1&id=3b8453a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8453a4",
  null
  
)

export default component.exports